(function () {
	'use strict';

	angular.module('dcApp').controller('UserProfileController', [
		'$rootScope',
		'$scope',
		'$stateParams',
		'toaster',
		'gettextCatalog',
		'MEMBER_ROLE_NAME',
		'ADMIN_ROLE_NAME',
		'PROJECT_ROLE_NAME',
		function (
			$rootScope,
			$scope,
			$stateParams,
			toaster,
			gettextCatalog,
			MEMBER_ROLE_NAME,
			ADMIN_ROLE_NAME,
			PROJECT_ROLE_NAME
		) {

			$scope.projectRoleName = PROJECT_ROLE_NAME;
			$scope.adminRoleName = ADMIN_ROLE_NAME;
			$scope.memberRoleName = MEMBER_ROLE_NAME;

			init();

			function init() {
				$scope.isNew = true;
				$scope.currentUser = {};
				$scope.currentUser.active = true;
				$scope.currentUser.visible = true;
				$scope.currentUser.editable = true;
				$scope.currentUser.locked = true;
				$scope.currentUser.password = '';
				$scope.currentUser.password_confirmation = '';
				$scope.currentUser.password = '';
				$scope.currentUser.email = $rootScope.account.mail;
				$scope.currentUser.first_name = $rootScope.account['firstname'];
				$scope.currentUser.last_name = $rootScope.account['lastname'];
				$scope.currentUser.locale = $rootScope.currentLangCode;
				$scope.currentUser.username = $rootScope.account.login;
				$scope.currentUser.roles =
					$rootScope.account['accounts'][0]['user_roles'];
			}

		},
	]);
})();
